import {Injectable} from '@angular/core';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-css-extras';
import 'prismjs/components/prism-docker';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-less';
import 'prismjs/components/prism-powershell';
import 'prismjs/components/prism-sass';
import 'prismjs/components/prism-scss';
import 'prismjs/components/prism-typescript';

@Injectable({
  providedIn: 'root',
})
export class PrismService {
  highlightAllUnder(element: HTMLElement) {
    Prism.highlightAllUnder(element);
  }
}
